import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ApplicationService } from '../../services/application.service';
import { Filters } from '../../models/filters.model';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  isLoading: boolean = false;
  datos: any[] = []; // Aquí van los datos que mostrarás en el reporte
  // datosFiltrados: any[] = [];

  // filtros = {
  //   nombre: '',
  //   fechaInicio: '',
  //   fechaFin: ''
  // };
  filtros: Filters = {
    FullName: '',
    FromDate: null,
    ToDate: null,
    page: 1,
    pageSize: 100
  };

  constructor(
    private applicationService: ApplicationService
  ) {}

  ngOnInit(): void {
    // Aquí podrías cargar los datos desde un servicio HTTP
    this.cargarAplicaciones()


    // this.datos = [
    //   { nombre: 'Juan Pérez', fecha: '2024-05-01', correo: 'juan@example.com' },
    //   { nombre: 'Ana García', fecha: '2024-05-10', correo: 'ana@example.com' },
    //   { nombre: 'Luis Soto', fecha: '2024-04-25', correo: 'luis@example.com' }
    // ];
    // this.aplicarFiltros();
  }

  // aplicarFiltros(): void {
  //   this.datosFiltrados = this.datos.filter(item => {
  //     const coincideNombre = this.filtros.nombre
  //       ? item.nombre.toLowerCase().includes(this.filtros.nombre.toLowerCase())
  //       : true;

  //     const fechaItem = new Date(item.fecha);
  //     const fechaInicio = this.filtros.fechaInicio ? new Date(this.filtros.fechaInicio) : null;
  //     const fechaFin = this.filtros.fechaFin ? new Date(this.filtros.fechaFin) : null;

  //     const coincideFecha =
  //       (!fechaInicio || fechaItem >= fechaInicio) &&
  //       (!fechaFin || fechaItem <= fechaFin);

  //     return coincideNombre && coincideFecha;
  //   });
  // }

  cargarAplicaciones() {
    this.isLoading = true;
    this.applicationService.GetFilteredApplications(this.filtros).subscribe(response => {
      if (response && response.listado) {
        this.datos = response.listado;
        console.log('Aplicaciones:', this.datos);
      } else {
        console.warn('No se encontró información en la respuesta.');
        this.datos = [];
      }
    });
  }
  getDownloadUrl(documentId: string): string {
    // Genera la URL de descarga (ajusta según tu API)
    return `${environment.url}/document/${documentId}`;
    
    // Ejemplo con parámetros adicionales:
    // return `${environment.apiUrl}/documents/download?id=${documentId}&token=${this.auth.getToken()}`;
  }
  exportarExcel(): void {
    const worksheet = XLSX.utils.json_to_sheet(this.datos);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');
    XLSX.writeFile(workbook, 'reporte.xlsx');
  }

  exportarPDF(): void {
    const doc = new jsPDF();
    const columnas = ['id','FirstName','MiddleName','LastName','Phone','Email','AddressLine1','Addressline2','City','State','Postal','College','MajorConcentration','Year','CollegeGpa','ExpectedYearOfGraduation','Essay','CreatedAt'];
    const filas = this.datos.map(item => [item.id, item.firstName, item.middleName, item.lastName, item.phone, item.email, item.addressLine1, item.addressline2, item.city, item.state, item.postal, item.college, item.majorConcentration, item.year, item.collegeGpa, item.expectedYearOfGraduation, item.essay, item.createdAt]);

    autoTable(doc, {
      head: [columnas],
      body: filas
    });

    doc.save('reporte.pdf');
  }
}